// Lists "assignments removed" emails that failed to send after a BambooHR position change.
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, List, message } from 'antd';
import api from '../../../authentication/axiosInstance';

const FailedPositionNotificationsBanner = ({ refreshKey }) => {
  const [items, setItems] = useState([]);
  const [resendingId, setResendingId] = useState(null);

  const loadFailed = useCallback(async () => {
    try {
      const response = await api.get('/bambooHR/position-notifications/failed/');
      setItems(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Failed to load position change notifications:', error);
    }
  }, []);

  useEffect(() => {
    loadFailed();
  }, [loadFailed, refreshKey]);

  const resend = async (item) => {
    setResendingId(item.id);
    try {
      const response = await api.post(`/bambooHR/position-notifications/${item.id}/resend/`);
      if (response.data?.state === 'succeeded') {
        message.success(`Notification for ${item.staff_name} sent`);
      } else {
        message.error(`Notification for ${item.staff_name} still failed: ${response.data?.last_error || 'unknown error'}`);
      }
    } catch (error) {
      console.error('Failed to resend position change notification:', error);
      message.error(`Failed to resend notification for ${item.staff_name}`);
    } finally {
      setResendingId(null);
      loadFailed();
    }
  };

  if (!items.length) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 12 }}
      message={`${items.length} removal notification${items.length === 1 ? '' : 's'} failed to send`}
      description={
        <List
          size="small"
          dataSource={items}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button key="resend" size="small" loading={resendingId === item.id} onClick={() => resend(item)}>
                  Resend
                </Button>,
              ]}
            >
              {item.staff_name}: {item.old_position} → {item.new_position} ({item.removed_count} assignment
              {item.removed_count === 1 ? '' : 's'} removed)
            </List.Item>
          )}
        />
      }
    />
  );
};

export default FailedPositionNotificationsBanner;
